import RouteTemplate from 'ember-route-template';
import LoadingSpinnerPulse from 'garaje/components/ui/classic/loading-spinner-pulse';

export default RouteTemplate(<template><LoadingSpinnerPulse /></template>);
